<template>
<div>
    <b-card no-body>
      <b-nav pills card-header slot="header" v-b-scrollspy:nav-scroller="50" align="center">
        <b-nav-item hidden href="#text5">@text5</b-nav-item>
        <b-nav-item hidden href="#text6">@text6</b-nav-item>
        Privacy
      </b-nav>

      <b-card-body
        id="nav-scroller"
        ref="content"
        style="position:relative; height:300px; overflow-y:scroll;"
        class="text-left"
      >
        <h5 class="font-weight-bold">INFORMATIVA resa ai sensi degli artt. 13 Regolamento (UE) 2016/679 (GDPR)</h5>
        <!-- <h6 class="font-weight-bold">Regolamento (UE) 2016/679 (GDPR)</h6> -->
        <p class="text-justify p-font-size"><span v-html="this.text_intro"></span></p>
        <h6 id="text1" class="font-weight-bold">1. Chi è il Titolare del trattamento</h6>
        <p class="text-justify p-font-size"><span v-html="this.text1"></span></p>
        <h6 id="text2" class="font-weight-bold">2. Categoria di dati trattati</h6>
          <p class="text-justify p-font-size2 mb-1 pl-3">2.1	Dati personali comuni</p>
          <p class="text-justify p-font-size pl-3 mb-1"><span v-html="this.text2_1_1"></span></p>
          <p class="text-justify p-font-size pl-4"><span v-html="this.text2_1_2"></span></p>
        <h6 id="text3" class="font-weight-bold">3. Finalità del trattamento e base giuridica </h6>
        <p class="text-justify p-font-size"><span v-html="this.text3"></span></p>
        <h6 id="text4" class="font-weight-bold">4. Natura del conferimento e conseguenze di un rifiuto di conferire i dati personali</h6>
        <p class="text-justify p-font-size"><span v-html="this.text4"></span></p>
        <h6 id="text5" class="font-weight-bold">5. Periodo di conservazione dei Suoi dati personali</h6>
        <p class="text-justify p-font-size"><span v-html="this.text5"></span></p>
        <h6 id="text6" class="font-weight-bold">6. Con quali modalità saranno trattati i Suoi dati personali</h6>
        <p class="text-justify p-font-size"><span v-html="this.text6"></span></p>
        <h6 id="text7" class="font-weight-bold">7. A quali soggetti potranno essere comunicati i Suoi dati personali e chi può venirne a conoscenza </h6>
        <p class="text-justify p-font-size"><span v-html="this.text7"></span></p>
        <h6 id="text8" class="font-weight-bold">8. I Suoi diritti in qualità di interessato</h6>
        <p class="text-justify p-font-size" style="padding-bottom:50px"><span v-html="this.text8"></span></p>
      </b-card-body>
    </b-card>
  </div>
</template>

<style scoped >
.card-footer {
    padding:0;
    border-top:0;
}

.p-font-size {
  font-size:0.9rem;
}

</style>

<script>
  export default {
    data() {
      return {
        text_intro: `
        Con il presente documento (l’“<b>Informativa</b>”), il Titolare del trattamento, 
        come di seguito definito, desidera informarLa sulle finalità e modalità 
        del trattamento dei Suoi dati personali e sui Suoi diritti in qualità di interessato.  
        `,
        text1: `
        Il Titolare del trattamento è CVA Energie S.r.l. a s.u., 
        con sede legale in Via Stazione n. 31, 11024 Châtillon (Aosta), 
        nella persona del legale rappresentante pro tempore (il “<b>Titolare</b>”).<br>
        Il Titolare ha nominato un Responsabile per la protezione dei dati personali (il “<b>DPO</b>”) 
        che Lei potrà contattare per l’esercizio dei Suoi diritti, elencati al successivo 
        punto <b>8.</b>, nonché per ricevere qualsiasi informazione relativamente al trattamento 
        dei Suoi dati personali, scrivendo a: <a href="mailto:privacy@cvaenergie.it">privacy@cvaenergie.it</a>.
        `,
        text2_1_1: `
        Per le finalità indicate nella presente Informativa, il Titolare tratta i dati personali comuni che sono:<br>
        `,
        text2_1_2: `
        &#8226; cognome e nome;<br>
        &#8226; numero di telefono/indirizzo e-mail.
        `,
        text3: `
        I dati personali raccolti potranno essere utilizzati dal Titolare nell'ambito della sua attività per le seguenti finalità:<br>
        &#8226; <b>senza il Suo consenso espresso</b>, per le seguenti finalità:<br>
        a) raccogliere ed elaborare i dati forniti, al fine di contrastare il fenomeno dei contatti per la proposizione di offerte commerciali, 
        effettuati impropriamente a nome della Società;<br>
        b) difendere nelle sedi opportune i diritti della Società, nonché tutelare quelli dei propri Clienti e dei consumatori da attività che 
        si pongono in violazione delle normative applicabili.<br>
        Il trattamento dei Suoi dati personali si fonda sulla seguente base giuridica:<br>
        a)	legittimo interesse del Titolare, ai sensi dell’art. 6, co. 1, lett. f).
        `,
        text4: `
        Il conferimento dei dati per le finalità di cui all’art. 3, lettera a) e b) è obbligatorio. In caso di mancato conferimento dei predetti 
        dati, CVA Energie S.r.l. a s.u. non sarà in grado di elaborare la Sua richiesta.
        `,
        text5: `
        I Suoi dati saranno conservati per tutta la durata delle esigenze di tutela dei diritti della Società, dei propri Clienti e dei consumatori; 
        al termine di tale periodo, e comunque entro 5 anni dalla raccolta, i Suoi dati verranno cancellati.
        `,
        text6: `
        Il trattamento dei Suoi dati personali avverrà mediante strumenti cartacei, informatici e telematici, con logiche strettamente correlate alle 
        finalità indicate e, comunque, con modalità idonee a garantirne la sicurezza e la riservatezza in conformità alle disposizioni previste dall’articolo 32 GDPR.
        `,
        text7: `
        Per il perseguimento delle finalità descritte al precedente paragrafo <b>3</b>., i dati personali trattati saranno conosciuti dai dipendenti, dal personale assimilato e 
        da collaboratori e/o consulenti del Titolare, nonché dalle altre società facenti parte del Gruppo CVA.<br>
        Inoltre, i Suoi dati personali potranno essere trattati da soggetti deputati alla vigilanza ed al controllo (a titolo esemplificativo, Collegio Sindacale, Società 
        di Revisione e Organismo di Vigilanza), nonché da Enti Certificatori.<br>
        I soggetti appartenenti alle categorie sopra riportate operano, alternativamente, in qualità di “autonomi” Titolari del trattamento, di Responsabili del trattamento 
        appositamente nominati dal Titolare nel rispetto dell’articolo 28 GDPR, ovvero in qualità di soggetti autorizzati al trattamento dei dati personali ai sensi dell’articolo 29 GDPR.
        `,
        text8: `
        In relazione ai trattamenti descritti nella presente Informativa, in qualità di interessato, Lei potrà, alle condizioni previste dal GDPR, 
        esercitare i diritti sanciti dagli articoli da 15 a 22 del GDPR quali, a titolo riassuntivo il diritto di accesso, di rettifica, l’integrazione 
        o la cancellazione dei suoi dati personali (c.d. diritto all’oblio), il diritto di ottenere la limitazione del trattamento e il diritto alla 
        portabilità dei dati, il diritto di opposizione al trattamento dei dati personali, compresa la profilazione e, infine, il diritto di proporre 
        reclamo all’Autorità Garante per la protezione dei dati personali.
        `,
      prova: true,
      div_procedi_vis:false
    }
    },
    methods: {
      onActivate(target) {
          //console.log('Received event: "bv::scrollspy::activate" for target ', target)
          if (target == "#text6"){
              this.$store.state.div_proc_vis = true
              // console.log(this.$store.state.div_proc_vis)
          } else {
              this.$store.state.div_proc_vis = false
              // console.log(this.$store.state.div_proc_vis)
          }
        }
    },
    created() {
    this.$root.$on('bv::scrollspy::activate', this.onActivate)
    },
  }
</script>